/*
Mesma ideia do BasicSelect (ver BasicSelect.tsx), mas com campo de busca — útil quando a lista
de opções é grande (ex.: tabelas de código do SEFAZ) e navegar direto pelo Select vira lento.

import { BasicAutoComplete } from '../../../shared/forms/BasicAutoComplete';

<BasicAutoComplete
  data={[
    { nameBD: 'casado', descricao: 'Casado (a)' },
    { nameBD: 'solteiro', descricao: 'Solteiro (a)' },
    { nameBD: 'divorciado', descricao: 'Divorciado (a)' },
  ]}
  label='Estado Civil'
  name='estadocivil'
/>
*/

import * as React from 'react';
import { useEffect, useState } from 'react';
import { Autocomplete, Box, TextField } from '@mui/material';
import { useField } from '@unform/core';

interface IDadosAutoComplete {
  nameBD: string;
  descricao: string;
}

interface BasicAutoCompleteProps {
  data: IDadosAutoComplete[];
  label: string;
  name: string;
  disabled: boolean;
  aoClicar?: (novoValor: string | undefined) => void;
}

export const BasicAutoComplete: React.FC<BasicAutoCompleteProps> = (props) => {
  const [value, setValue] = useState('');

  const { fieldName, registerField, error, clearError } = useField(props.name);

  useEffect(() => {
    registerField({
      name: fieldName,
      getValue: () => value,
      setValue: (_, newValue) => setValue(newValue ?? ''),
    });
  }, [registerField, fieldName, value]);

  const opcaoSelecionada = props.data.find((item) => item.nameBD === value) ?? null;

  return (
    <Box>
      <Autocomplete
        openText='Abrir'
        closeText='Fechar'
        noOptionsText='Sem opções'
        disablePortal
        size='small'
        fullWidth
        options={props.data}
        getOptionLabel={(item) => item.descricao}
        isOptionEqualToValue={(option, val) => option.nameBD === val.nameBD}
        value={opcaoSelecionada}
        disabled={props.disabled}
        onChange={(_, newValue) => {
          clearError();
          setValue(newValue?.nameBD ?? '');
          props.aoClicar?.(newValue?.nameBD);
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label={props.label}
            error={!!error}
            helperText={error}
          />
        )}
      />
    </Box>
  );
};
